import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { useId } from 'react'

export type AmountFieldProps = {
    label: string
    /** Text tak, jak ho uživatel píše - převod na haléře řeší volající. */
    value: string
    onChange: (value: string) => void
    currencySymbol?: string
    error?: string
    helpText?: string
    disabled?: boolean
    required?: boolean
    autoFocus?: boolean
    size?: 'sm' | 'lg'
}

/**
 * Pole pro peněžní částku. Na mobilu vyvolá číselnou klávesnici a přijímá
 * desetinnou čárku i tečku.
 */
export function AmountField({ label, value, onChange, currencySymbol, error, helpText, size, ...rest }: AmountFieldProps) {
    const id = useId()

    return (
        <Form.Group className="mb-3" controlId={id}>
            <Form.Label>{label}</Form.Label>
            <InputGroup hasValidation size={size}>
                <Form.Control
                    type="text"
                    inputMode="decimal"
                    value={value}
                    isInvalid={!!error}
                    className="su-tappable text-end"
                    onChange={(event) => onChange(event.target.value)}
                    {...rest}
                />
                {currencySymbol && <InputGroup.Text>{currencySymbol}</InputGroup.Text>}
                {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
            </InputGroup>
            {helpText && !error && <Form.Text className="text-muted">{helpText}</Form.Text>}
        </Form.Group>
    )
}
